/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import includes from 'lodash/includes';
import { listingManagementActionType as actions } from '~constants/actionTypes';
import endpoints from '~settings/endpoints';
import { fetch } from '~actions/shared';
import * as queries from '~settings/queries';
import { message } from 'antd';
import i18n from '~settings/i18n';
import { onlyViewPropertyRole } from '~client/helpers/auth';

export const setProperty = payload => ({
  type: actions.SET_PROPERTY,
  payload: payload.property,
});

// this function overrides the existing property.
export const overrideProperty = payload => ({
  type: actions.SET_PROPERTY,
  payload: payload.property,
  override: true,
});

export const getPropertyDetail =
  (slug, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.getPropertyDetail.url(),
      params: queries.getPropertyDetail({ slug }, !onlyViewPropertyRole()),
      communicationType: actions.GET_PROPERTY_CS,
      successAction: overrideProperty,
      onSuccess: res => {
        successCallback(res);
      },
      onError: e => {
        if (e && e[0] && e[0].message === 'invalid node id.') {
          message.error(i18n.t('cms.properties.edit.toast.error.property_not_exist'));
        } else {
          message.error(i18n.t('cms.properties.edit.toast.error'));
        }
      },
    });
  };

export const publishProperty =
  (
    params,
    successCallback = () => {},
    validateErrCallback = () => {},
    inativeErrorCallback = () => {},
  ) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.publishProperty.url(),
      params: queries.publishProperty(params),
      communicationType: actions.PUBLISH_PROPERTY_CS,
      onSuccess: data => {
        const { status, error, description } = data.publishProperty;
        if (status === 'FAILED') {
          if (
            error === 'PROPERTY_CITY_UNPUBLISHED' ||
            error === 'PROPERTY_PENDING_DRAFT_EXISTS' ||
            error === 'PROPERTY_REJECTED_DRAFT_EXISTS'
          ) {
            message.error(
              i18n.t('cms.properties.edit.detail.city.state_invalid', {
                invalid: description,
              }),
            );
          } else if (description) {
            message.error(description);
          } else {
            message.error(i18n.t('cms.properties.edit.toast.error'));
          }
          return;
        }
        if (successCallback) {
          successCallback();
        }
      },
      onError: (errors, code) => {
        if (
          (params.publish &&
            errors &&
            errors[0] &&
            includes(
              ['VALIDATE_PAYMENT_PLAN_FAIL', 'INVALID_PROPERTY_PAYOUT_METHOD'],
              errors[0].message,
            )) ||
          (code && includes(['VALIDATE_PAYMENT_PLAN_FAIL', 'INVALID_PROPERTY_PAYOUT_METHOD'], code))
        ) {
          validateErrCallback(code || errors[0].message);
        } else if (code && includes(['PAYMENT_PLAN_NOT_ACTIVE'], code)) {
          inativeErrorCallback();
        } else if (errors?.[0]?.extensions?.code === 'LISTING_AVAILABILITY_SET_TO_NULL') {
          message.error(i18n.t('cms.properties.edit.publish.listing_error'));
        } else {
          message.error(i18n.t(errors?.[0]?.message || 'cms.properties.edit.toast.error'));
        }
      },
    });
  };

export const getPropertyPreview =
  (slug, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.getGeneralUrl.url(),
      params: queries.getPropertyPreview({ slug }),
      communicationType: actions.GET_PROPERTY_PREVIEW_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: e => {
        if (e && e[0] && e[0].message === 'invalid node id.') {
          message.error(i18n.t('cms.properties.edit.toast.error.property_not_exist'));
        } else {
          message.error(i18n.t('cms.properties.edit.toast.error'));
        }
      },
    });
  };

export const deleteRoom =
  (id, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.deleteRoom.url(),
      params: queries.deleteRoom({ id }),
      communicationType: actions.DELETE_ROOM_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const createRoom =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.createRoom.url(),
      params: queries.createRoom(params),
      communicationType: actions.CREATE_ROOM_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const updateRoom =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.updateRoom(params),
      communicationType: actions.UPDATE_ROOM_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const setNeedConfirmRoomListing = params => ({
  type: actions.SET_NEED_CONFIRM_ROOM_LISTING,
  payload: params,
});

export const createListing =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.createListing(params),
      communicationType: actions.CREATE_LISTING_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const updateListing =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.updateListing(params),
      communicationType: actions.UPDATE_LISTING_CS,
      onSuccess: successCallback,
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const deleteListing =
  (id, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.deleteListing({ id }),
      communicationType: actions.DELETE_LISTING_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const bulkDeleteListings =
  (ids, successCallback = () => {}, errorCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.bulkDeleteListings({ ids }),
      communicationType: actions.BULK_DELETE_LISTING_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
        errorCallback();
      },
    });
  };

export const bulkUpdateListings =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.bulkUpdateListings(params),
      communicationType: actions.BULK_UPDATE_LISTING_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const updateGallery =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.updateGallery(params),
      communicationType: actions.UPDATE_GALLERY_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };

export const getUnitTypeFacilities =
  (successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: queries.queryUnitTypeFacilities(),
      communicationType: actions.GET_UNIT_TYPE_FACILITIES,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };
